import { Controller } from "stimulus";

// The Assign button lives in the panel's fixed header, above the (possibly long, scrollable)
// candidate list -- rather than wiring a target to every checkbox, this listens for "change"
// bubbling up from any of them and just re-checks the DOM directly.
export default class extends Controller {
  static targets = ["submit", "warning"];
  static values = { openPlaces: Number };

  declare readonly submitTarget: HTMLButtonElement;
  declare readonly warningTarget: HTMLElement;
  declare readonly openPlacesValue: number;

  connect(): void {
    this.refresh();
  }

  refresh(): void {
    const checkedCount = this.element.querySelectorAll(
      'input[type="checkbox"]:checked'
    ).length;
    this.submitTarget.disabled = checkedCount === 0;

    // Capacity is a warning, not a hard block (plan doc 3.7/6.2) -- Talent can still assign
    // over it, they just need to see it happening.
    const overCapacity = checkedCount > this.openPlacesValue;
    this.warningTarget.hidden = !overCapacity;
    if (overCapacity) {
      this.warningTarget.textContent = `${checkedCount} selected — only ${this.openPlacesValue} place(s) left`;
    }
  }
}
